<template>
  <v-dialog v-model="showDialogCreateQuickResponse" width="420" persistent>
    <v-card>
      <div class="quick-response-dialog-header">
        <div class="quick-response-dialog-title">
          {{ $t('createNewQuickResponse') | capitalize }}
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="cancel">
          <v-icon color="#8B8FA3">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-form ref="createQuickResponseForm" class="quick-response-form">
        <v-text-field v-model="_id" style="display: none"/>
        <v-text-field v-model="type" style="display: none"/>
        <v-text-field
            v-model="title"
            background-color="#D6D9E6"
            flat
            single-line
            outline
            height="37px"
            :rules="[formRules.ruleRequired, formRules.ruleCounter(100), formRules.ruleAgentQuickResponseTitle]"
            :placeholder="$t('quickResponseForm.title') | capitalize"/>
            <v-select
            v-if="type===1"
            v-model="skillGroup"
            background-color="#D6D9E6"
            flat
            single-line
            outline
            height="37px"
            item-text="name"
            item-value="id"
            :items="skillGroupOptionsLeader"
            append-icon=""
            :placeholder="$t('skillGroup') | capitalize"/>
            <v-select
            v-if="type===0"
            v-model="skillGroup"
            background-color="#D6D9E6"
            flat
            single-line
            outline
            height="37px"
            item-text="name"
            item-value="id"
            :items="skillGroupOptions"
            append-icon=""
            :rules="[ v => (v !== null && v !== undefined && v !== '' && skillGroupOptions.some(option => option.id === v)) || this.$t('formRules.fieldRequired')]"
            :placeholder="$t('skillGroup') | capitalize"/>
        <v-textarea
            v-model="content"
            ref="blockReason"
            background-color="#D6D9E6"
            auto-grow
            flat
            outline
            rows="5"
            :rules="formRules.required"
            :placeholder="$t('quickResponseForm.content') | capitalize"
            :hide-details="hideDetails"
        ></v-textarea>
        <div class="variable-picker">
          <div class="variable-item" v-for="item of Object.keys(crmData)" @click="onAddVariable(item)">
            <span>{{item}}</span>
          </div>
        </div>
        <div class="dialog-action">
          <v-btn small outline color="#0052CC" style="margin-left: auto" @click="cancel">{{$t('cancel') | capitalize}}</v-btn>
          <v-btn small color="#0052CC" class="white--text" @click="submit">{{$t('save') | capitalize}}</v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormMixin from "@/mixins/FormMixin";
import {mapFields} from "vuex-map-fields";

export default {
  name: "DialogCreateQuickResponse",
  mixins: [FormMixin],
  data() {
    return {
      hideDetails: true
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState('dialog', ['showDialogCreateQuickResponse']),
    ...mapFields('agentQuickResponse', ['title', 'content', "_id", "type", "group", "skillGroup"]),
    ...mapState('autoAssign',['autoAssignCfg']),
    ...mapState('crm', ['crmData']),
    // itemNames() {
    //   return this.dataItems.map(item => item.name);
    // },
      skillGroupOptionsLeader: function(){
        if (this.autoAssignCfg.rs_categories){
          // let result = this.autoAssignCfg.rs_categories.concat({ id: 0, name: this.$t("noSkill") });
          let result = [...this.autoAssignCfg.rs_categories]; // Clone the array to avoid mutating the original array
          result.unshift({ id: 0, name: this.$t("noSkill") });
          return result
        }
        return []
      },
      skillGroupOptions: function(){
          if (this.autoAssignCfg.rs_categories && this.autoAssignCfg.supporters){
            let foundSupporter = this.autoAssignCfg.supporters.find(item => item.id === this.user.id);
            let currentRsCategories = (foundSupporter && foundSupporter.auto_assign_config.request_support_categories) ? foundSupporter.auto_assign_config.request_support_categories : []
            
            let idMap = {};
            for (let item of this.autoAssignCfg.rs_categories) {
                idMap[item.id] = item;
            }

            let result = [];
            for (let id of currentRsCategories) {
                if (idMap[id]) {
                    result.push(idMap[id]);
                }
            }
            if (result.length === 0){
              result.unshift({ id: 0, name: this.$t("noSkill") });
            }
            return result
          }
          return [{ id: 0, name: this.$t("noSkill") }]
        }
  },
  mounted (){
    this.skillGroup = null
  },
  methods: {
    ...mapActions('dialog', ['closeDialogCreateQuickResponse']),
    ...mapActions('agentQuickResponse', ['saveAgentQuickResponse', 'updateQuickResponse']),
    submit() {
      if(this.skillGroup===null){
        this.skillGroup=0
      }
      if (this.$refs.createQuickResponseForm.validate()) {
        //Update
        if (this._id) {
          this.updateQuickResponse(this.type)
        }
        //Create
        else {
          this.saveAgentQuickResponse()
        }
        this.$refs.createQuickResponseForm.reset()
      }
      else {
        this.hideDetails = false
      }
    },
    cancel() {
      this.$refs.createQuickResponseForm.reset()
      this.hideDetails = true;
      this.closeDialogCreateQuickResponse()
    },
    onAddVariable(item) {
      if(this.content  !== undefined) {
        this.content = this.content + `{${item}}`
      }
      else {
        this.content = `{${item}}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "components/style/dialog-create-quick-response";
::v-deep .custom-input-append .v-input__append-inner{
display: none;
}
</style>
